import { render, staticRenderFns } from "./OrderOverviewPage.vue?vue&type=template&id=8c352560&scoped=true&"
import script from "./OrderOverviewPage.vue?vue&type=script&lang=js&"
export * from "./OrderOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./OrderOverviewPage.vue?vue&type=style&index=0&id=8c352560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c352560",
  null
  
)

export default component.exports